import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ScheduleService {
  constructor(public http: HttpClient) {
    // super("", http);
  }
  getSectionsAndSubjectsForClassRoomView() {
    const arrList = [
      {
        SectionId: 1,
        SectionName: 'G1 -A (2017  - 2018)',
        subjectList: [
          { id: 1, time: '08:00AM - 09:00AM', subject: 'Chemestry', teacher: ['Tommy Risser'], rooms: null },
          { id: 2, time: '09:00AM - 10:00AM', subject: 'physics', teacher: ['Lakesha Porch'], rooms: null },
          { id: 3, time: '11:00AM - 12:00AM', subject: 'Maths', teacher: ['Benjamin Crumpler'], rooms: null },
          { id: 4, time: '01:00AM - 02:00AM', subject: 'Science', teacher: ['Fanny Stenberg'], rooms: null },
          { id: 5, time: '02:00AM - 03:00AM', subject: 'Social', teacher: ['Michaela Kloss'], rooms: null },
          { id: 6, time: '04:00AM - 05:00AM', subject: 'Arts', teacher: ['Donte Mcdaniels'], rooms: null }
        ]
      },
      {
        SectionId: 2,
        SectionName: 'G1 -B (2017  - 2018)',
        subjectList: [
          { id: 1, time: '08:00AM - 09:00AM', subject: 'Chemestry', teacher: ['Tommy Risser'], rooms: null },
          { id: 2, time: '09:00AM - 10:00AM', subject: 'physics', teacher: ['Lakesha Porch'], rooms: null },
          { id: 9, time: '11:00AM - 12:00AM', subject: 'Maths', teacher: ['Benjamin Crumpler'], rooms: null },
          { id: 10, time: '01:00AM - 02:00AM', subject: 'Science', teacher: ['Fanny Stenberg'], rooms: null },
          { id: 11, time: '02:00AM - 03:00AM', subject: 'Social', teacher: ['Michaela Kloss'], rooms: null },
          { id: 12, time: '04:00AM - 05:00AM', subject: 'Arts', teacher: ['Donte Mcdaniels'], rooms: null }
        ]
      },
      {
        SectionId: 3,
        SectionName: 'G1 -C (2017  - 2018)',
        subjectList: [
          { id: 1, time: '08:00AM - 09:00AM', subject: 'Chemestry', teacher: ['Tommy Risser'], rooms: null },
          { id: 2, time: '09:00AM - 10:00AM', subject: 'physics', teacher: ['Lakesha Porch'], rooms: null },
          { id: 15, time: '11:00AM - 12:00AM', subject: 'Maths', teacher: ['Benjamin Crumpler'], rooms: null },
          { id: 16, time: '01:00AM - 02:00AM', subject: 'Science', teacher: ['Fanny Stenberg'], rooms: null },
          { id: 17, time: '02:00AM - 03:00AM', subject: 'Social', teacher: ['Michaela Kloss'], rooms: null },
          { id: 18, time: '04:00AM - 05:00AM', subject: 'Arts', teacher: ['Donte Mcdaniels'], rooms: null }
        ]
      },
      {
        SectionId: 4,
        SectionName: 'G1 -D (2017  - 2018)',
        subjectList: [
          {
            id: 19, 
            time: '08:00AM - 09:00AM', 
            subject: 'Languages', 
            teacher: ['Tommy Risser', 'Teacher 2'], 
            rooms: null,
            subSubjects: [
              {
                "id": 20,
                "name": "English",
                "assignedTeachers": [
                  {
                    "id": 20,
                    "name": "teacher E1",
                    "allottedWorkingHours": 10,
                    "actualWorkingHours": 0
                  },
                  {
                    "id": 21,
                    "name": "teacher E2",
                    "allottedWorkingHours": 10,
                    "actualWorkingHours": 0
                  },
                  {
                    "id": 22,
                    "name": "teacher E3",
                    "allottedWorkingHours": 10,
                    "actualWorkingHours": 0
                  }
                ]
              },
              {
                "id": 21,
                "name": "Arabic",
                "assignedTeachers": [
                  {
                    "id": 30,
                    "name": "teacher A1",
                    "allottedWorkingHours": 10,
                    "actualWorkingHours": 0
                  },
                  {
                    "id": 31,
                    "name": "teacher A2",
                    "allottedWorkingHours": 10,
                    "actualWorkingHours": 0
                  },
                  {
                    "id": 32,
                    "name": "teacher A3",
                    "allottedWorkingHours": 10,
                    "actualWorkingHours": 0
                  }
                ]
              },
              {
                "id": 22,
                "name": "Urdu",
                "assignedTeachers": [
                  {
                    "id": 40,
                    "name": "teacher U1",
                    "allottedWorkingHours": 10,
                    "actualWorkingHours": 0
                  },
                  {
                    "id": 41,
                    "name": "teacher U2",
                    "allottedWorkingHours": 10,
                    "actualWorkingHours": 0
                  },
                  {
                    "id": 42,
                    "name": "teacher U3",
                    "allottedWorkingHours": 10,
                    "actualWorkingHours": 0
                  }
                ]
              }
            ]
          },
          { id: 21, time: '11:00AM - 12:00AM', subject: 'Maths', teacher: ['Benjamin Crumpler'], rooms: null },
          { id: 22, time: '01:00AM - 02:00AM', subject: 'Science', teacher: ['Fanny Stenberg'], rooms: null },
          { id: 23, time: '02:00AM - 03:00AM', subject: 'Social', teacher: ['Michaela Kloss'], rooms: null },
          { id: 24, time: '04:00AM - 05:00AM', subject: 'Arts', teacher: ['Donte Mcdaniels'], rooms: null }
        ]
      }
    ];
    return arrList;
  }

  getStudentViewSchedule(filter) {
    const arr = [
      {
        id: 1,
        day: 'San',
        periods: [
          { id: 1, name: 'Period #1', time: '08:00AM - 09:00AM', subject: 'Languages', teacher: 'Teacher 1, Teacher 2', rooms: 'Room 1, Room 2' },
          { id: 1, name: 'Period #1', time: '08:00AM - 09:00AM', subject: 'Geography', teacher: 'Teacher 1', rooms: 'Room 3' },
          { id: 3, name: 'Period #3', time: '11:00AM - 12:00AM', subject: 'Maths', teacher: 'Tommy Risser', rooms: 'Room 4' },
          { isBreak: true, id: 1, time: '01 Hr' },
          { id: 4, name: 'Period #4', time: '01:00AM - 02:00AM', subject: 'Polyology', teacher: 'Tommy Risser', rooms: 'Room 5' },
          { id: 5, name: 'Period #5', time: '02:00AM - 03:00AM', subject: 'History', teacher: 'Tommy Risser', rooms: 'Room 6' },
          { id: 6, name: 'Period #6', time: '04:00AM - 05:00AM', subject: 'Social', teacher: 'Tommy Risser', rooms: 'Room 7' },
          { id: 5, name: 'Period #7', time: '02:00AM - 03:00AM', subject: 'Chemestry', teacher: 'Tommy Risser', rooms: 'Room 8' },
          { isBreak: true, id: 1, time: '01 Hr' },
          { id: 6, name: 'Period #8', time: '04:00AM - 05:00AM', subject: 'Social', teacher: 'Tommy Risser', rooms: 'Room 9' }
        ]
      },
      {
        id: 2,
        day: 'Mon',
        periods: [
          { id: 7, name: 'Period #1', time: '08:00AM - 09:00AM', subject: 'Physics', teacher: 'Tommy Risser', rooms: 'Room 10' },
          { id: 8, name: 'Period #2', time: '09:00AM - 10:00AM', subject: 'Chemestry', teacher: 'Tommy Risser', rooms: 'Room 11' },
          { id: 9, name: 'Period #3', time: '11:00AM - 12:00AM', subject: 'Maths', teacher: 'Tommy Risser', rooms: 'Room 12' },
          { isBreak: true, id: 1, time: '01 Hr' },
          { id: 10, name: 'Period #4', time: '01:00AM - 02:00AM', subject: 'Phisics', teacher: 'Tommy Risser', rooms: 'Room 13' },
          { id: 11, name: 'Period #5', time: '02:00AM - 03:00AM', subject: 'History', teacher: 'Tommy Risser', rooms: 'Room 14' },
          { id: 12, name: 'Period #6', time: '04:00AM - 05:00AM', subject: 'Social', teacher: 'Tommy Risser', rooms: 'Room 15' },
          { id: 11, name: 'Period #7', time: '02:00AM - 03:00AM', subject: 'Geography', teacher: 'Tommy Risser', rooms: 'Room 16' },
          { isBreak: true, id: 1, time: '01 Hr' },
          { id: 13, name: 'Period #8', time: '04:00AM - 05:00AM', subject: 'Social', teacher: 'Tommy Risser', rooms: 'Room 17' }
        ]
      },
      {
        id: 3,
        day: 'Tue',
        periods: [
          { id: 7, name: 'Period #1', time: '08:00AM - 09:00AM', subject: 'Physics', teacher: 'Tommy Risser', rooms: 'Room A' },
          { id: 8, name: 'Period #2', time: '09:00AM - 10:00AM', subject: 'Chemestry', teacher: 'Tommy Risser', rooms: 'Room B' },
          { isBreak: true, id: 1, time: '01 Hr' },
          { id: 9, name: 'Period #3', time: '11:00AM - 12:00AM', subject: 'Maths', teacher: 'Tommy Risser', rooms: 'Room C' },
          { isBreak: true, id: 1, time: '01 Hr' },
          { id: 10, name: 'Period #4', time: '01:00AM - 02:00AM', subject: 'Phisics', teacher: 'Tommy Risser', rooms: 'Room A' },
          { id: 11, name: 'Period #5', time: '02:00AM - 03:00AM', subject: 'History', teacher: 'Tommy Risser', rooms: 'Room A' },
          { id: 12, name: 'Period #6', time: '04:00AM - 05:00AM', subject: 'Social', teacher: 'Tommy Risser', rooms: 'Room A' },
          { id: 11, name: 'Period #7', time: '02:00AM - 03:00AM', subject: 'Geography', teacher: 'Tommy Risser', rooms: 'Room A' },
          { id: 13, name: 'Period #8', time: '04:00AM - 05:00AM', subject: 'Social', teacher: 'Tommy Risser', rooms: 'Room A' }
        ]
      },
      {
        id: 4,
        day: 'Wed',
        periods: [
          { id: 7, name: 'Period #1', time: '08:00AM - 09:00AM', subject: 'Physics', teacher: 'Tommy Risser', rooms: 'Room A' },
          { id: 8, name: 'Period #2', time: '09:00AM - 10:00AM', subject: 'Chemestry', teacher: 'Tommy Risser', rooms: 'Room A' },
          { id: 9, name: 'Period #3', time: '11:00AM - 12:00AM', subject: 'Maths', teacher: 'Tommy Risser', rooms: 'Room A' },
          { isBreak: true, id: 1, time: '01 Hr' },
          { id: 10, name: 'Period #4', time: '01:00AM - 02:00AM', subject: 'Phisics', teacher: 'Tommy Risser', rooms: 'Room A' },
          { id: 11, name: 'Period #5', time: '02:00AM - 03:00AM', subject: 'History', teacher: 'Tommy Risser', rooms: 'Room A' },
          { id: 12, name: 'Period #6', time: '04:00AM - 05:00AM', subject: 'Social', teacher: 'Tommy Risser', rooms: 'Room A' },
          { isBreak: true, id: 1, time: '01 Hr' },
          { id: 11, name: 'Period #7', time: '02:00AM - 03:00AM', subject: 'Geography', teacher: 'Tommy Risser', rooms: 'Room A' },
          { id: 13, name: 'Period #8', time: '04:00AM - 05:00AM', subject: 'Social', teacher: 'Tommy Risser', rooms: 'Room A' }
        ]
      },
      {
        id: 5,
        day: 'Thu',
        periods: [
          { id: 7, name: 'Period #1', time: '08:00AM - 09:00AM', subject: 'Physics', teacher: 'Tommy Risser', rooms: 'Room A' },
          { id: 8, name: 'Period #2', time: '09:00AM - 10:00AM', subject: 'Chemestry', teacher: 'Tommy Risser', rooms: 'Room A' },
          { id: 9, name: 'Period #3', time: '11:00AM - 12:00AM', subject: 'Maths', teacher: 'Tommy Risser', rooms: 'Room A' },
          { isBreak: true, id: 1, time: '01 Hr' },
          { id: 10, name: 'Period #4', time: '01:00AM - 02:00AM', subject: 'Phisics', teacher: 'Tommy Risser', rooms: 'Room A' },
          { id: 11, name: 'Period #5', time: '02:00AM - 03:00AM', subject: 'History', teacher: 'Tommy Risser', rooms: 'Room A' },
          { isBreak: true, id: 1, time: '01 Hr' },
          { id: 12, name: 'Period #6', time: '04:00AM - 05:00AM', subject: 'Social', teacher: 'Tommy Risser', rooms: 'Room A' },
          { id: 11, name: 'Period #7', time: '02:00AM - 03:00AM', subject: 'Geography', teacher: 'Tommy Risser', rooms: 'Room A' },
          { id: 13, name: 'Period #8', time: '04:00AM - 05:00AM', subject: 'Social', teacher: 'Tommy Risser', rooms: 'Room A' }
        ]
      }
    ];

    return arr;
  }
  getStudentViewScheduleById(id) {
    const arr1 = [
      {
        id: 1,
        day: 'San',
        periods: [
          { id: 1, name: 'Period #1', time: '08:00AM - 09:00AM', subject: 'Arabic', teacher: 'Teacher 1', rooms: 'Room 1' },
          { id: 1, name: 'Period #1', time: '08:00AM - 09:00AM', subject: 'History', teacher: 'Teacher 1', rooms: 'Room 4' },
          { id: 3, name: 'Period #3', time: '11:00AM - 12:00AM', subject: 'Maths', teacher: 'Tommy Risser', rooms: 'Room 3' },
          { isBreak: true, id: 1, time: '01 Hr' },
          { id: 4, name: 'Period #4', time: '01:00AM - 02:00AM', subject: 'Chemestry', teacher: 'Tommy Risser', rooms: 'Room 2' },
          { id: 5, name: 'Period #5', time: '02:00AM - 03:00AM', subject: 'Geography', teacher: 'Tommy Risser', rooms: 'Room 4' },
          { id: 6, name: 'Period #6', time: '04:00AM - 05:00AM', subject: 'Social', teacher: 'Tommy Risser', rooms: 'Room 12' },
          { id: 5, name: 'Period #7', time: '02:00AM - 03:00AM', subject: 'Polyology', teacher: 'Tommy Risser', rooms: 'Room A' },
          { isBreak: true, id: 1, time: '01 Hr' },
          { id: 6, name: 'Period #8', time: '04:00AM - 05:00AM', subject: 'Social', teacher: 'Tommy Risser', rooms: 'Room b' }
        ]
      },
      {
        id: 2,
        day: 'Mon',
        periods: [
          { id: 7, name: 'Period #1', time: '08:00AM - 09:00AM', subject: 'Physics', teacher: 'Tommy Risser', rooms: 'Room 10' },
          { id: 8, name: 'Period #2', time: '09:00AM - 10:00AM', subject: 'Chemestry', teacher: 'Tommy Risser', rooms: 'Room 4' },
          { id: 9, name: 'Period #3', time: '11:00AM - 12:00AM', subject: 'Maths', teacher: 'Tommy Risser', rooms: 'Room 4' },
          { isBreak: true, id: 1, time: '01 Hr' },
          { id: 10, name: 'Period #4', time: '01:00AM - 02:00AM', subject: 'Phisics', teacher: 'Tommy Risser', rooms: 'Room 5' },
          { id: 11, name: 'Period #5', time: '02:00AM - 03:00AM', subject: 'History', teacher: 'Tommy Risser', rooms: 'Room 4' },
          { id: 12, name: 'Period #6', time: '04:00AM - 05:00AM', subject: 'Social', teacher: 'Tommy Risser', rooms: 'Room 8' },
          { id: 11, name: 'Period #7', time: '02:00AM - 03:00AM', subject: 'Geography', teacher: 'Tommy Risser', rooms: 'Room 4' },
          { isBreak: true, id: 1, time: '01 Hr' },
          { id: 13, name: 'Period #8', time: '04:00AM - 05:00AM', subject: 'Social', teacher: 'Tommy Risser', rooms: 'Room 4' }
        ]
      },
      {
        id: 3,
        day: 'Tue',
        periods: [
          { id: 7, name: 'Period #1', time: '08:00AM - 09:00AM', subject: 'Physics', teacher: 'Tommy Risser', rooms: 'Room 4' },
          { id: 8, name: 'Period #2', time: '09:00AM - 10:00AM', subject: 'Chemestry', teacher: 'Tommy Risser', rooms: 'Room 4' },
          { id: 9, name: 'Period #3', time: '11:00AM - 12:00AM', subject: 'Maths', teacher: 'Tommy Risser', rooms: 'Room 4' },
          { isBreak: true, id: 1, time: '01 Hr' },
          { id: 10, name: 'Period #4', time: '01:00AM - 02:00AM', subject: 'Phisics', teacher: 'Tommy Risser', rooms: 'Room 4' },
          { id: 11, name: 'Period #5', time: '02:00AM - 03:00AM', subject: 'History', teacher: 'Tommy Risser', rooms: 'Room 4' },
          { id: 12, name: 'Period #6', time: '04:00AM - 05:00AM', subject: 'Social', teacher: 'Tommy Risser', rooms: 'Room 4' },
          { id: 11, name: 'Period #7', time: '02:00AM - 03:00AM', subject: 'Geography', teacher: 'Tommy Risser', rooms: 'Room 4' },
          { isBreak: true, id: 1, time: '01 Hr' },
          { id: 13, name: 'Period #8', time: '04:00AM - 05:00AM', subject: 'Social', teacher: 'Tommy Risser', rooms: 'Room 4' }
        ]
      },
      {
        id: 4,
        day: 'Wed',
        periods: [
          { id: 7, name: 'Period #1', time: '08:00AM - 09:00AM', subject: 'Physics', teacher: 'Tommy Risser', rooms: 'Room 4' },
          { id: 8, name: 'Period #2', time: '09:00AM - 10:00AM', subject: 'Chemestry', teacher: 'Tommy Risser', rooms: 'Room 4' },
          { id: 9, name: 'Period #3', time: '11:00AM - 12:00AM', subject: 'Maths', teacher: 'Tommy Risser', rooms: 'Room 4' },
          { isBreak: true, id: 1, time: '01 Hr' },
          { id: 10, name: 'Period #4', time: '01:00AM - 02:00AM', subject: 'Phisics', teacher: 'Tommy Risser', rooms: 'Room 4' },
          { id: 11, name: 'Period #5', time: '02:00AM - 03:00AM', subject: 'History', teacher: 'Tommy Risser', rooms: 'Room 4' },
          { id: 12, name: 'Period #6', time: '04:00AM - 05:00AM', subject: 'Social', teacher: 'Tommy Risser', rooms: 'Room 4' },
          { id: 11, name: 'Period #7', time: '02:00AM - 03:00AM', subject: 'Geography', teacher: 'Tommy Risser', rooms: 'Room 4' },
          { isBreak: true, id: 1, time: '01 Hr' },
          { id: 13, name: 'Period #8', time: '04:00AM - 05:00AM', subject: 'Social', teacher: 'Tommy Risser', rooms: 'Room 4' }
        ]
      },
      {
        id: 5,
        day: 'Thu',
        periods: [
          { id: 7, name: 'Period #1', time: '08:00AM - 09:00AM', subject: 'Physics', teacher: 'Tommy Risser', rooms: 'Room 4' },
          { id: 8, name: 'Period #2', time: '09:00AM - 10:00AM', subject: 'Chemestry', teacher: 'Tommy Risser', rooms: 'Room 4' },
          { id: 9, name: 'Period #3', time: '11:00AM - 12:00AM', subject: 'Maths', teacher: 'Tommy Risser', rooms: 'Room 4' },
          { isBreak: true, id: 1, time: '01 Hr' },
          { id: 10, name: 'Period #4', time: '01:00AM - 02:00AM', subject: 'Phisics', teacher: 'Tommy Risser', rooms: 'Room 4' },
          { id: 11, name: 'Period #5', time: '02:00AM - 03:00AM', subject: 'History', teacher: 'Tommy Risser', rooms: 'Room 4' },
          { id: 12, name: 'Period #6', time: '04:00AM - 05:00AM', subject: 'Social', teacher: 'Tommy Risser', rooms: 'Room 4' },
          { id: 11, name: 'Period #7', time: '02:00AM - 03:00AM', subject: 'Geography', teacher: 'Tommy Risser', rooms: 'Room 4' },
          { isBreak: true, id: 1, time: '01 Hr' },
          { id: 13, name: 'Period #8', time: '04:00AM - 05:00AM', subject: 'Social', teacher: 'Tommy Risser', rooms: 'Room 4' }
        ]
      }
    ];

    const arr2 = [
      {
        id: 1,
        day: 'San',
        periods: [
          { id: 1, name: 'Period #1', time: '08:00AM - 09:00AM', subject: 'English', teacher: 'Teacher 2', rooms: 'Room 2' },
          { id: 1, name: 'Period #1', time: '08:00AM - 09:00AM', subject: 'History', teacher: 'Teacher 1', rooms: 'Room 12' },
          { id: 3, name: 'Period #3', time: '11:00AM - 12:00AM', subject: 'Maths', teacher: 'Tommy Risser', rooms: 'Room 10' },
          { isBreak: true, id: 1, time: '01 Hr' },
          { id: 4, name: 'Period #4', time: '01:00AM - 02:00AM', subject: 'Chemestry', teacher: 'Tommy Risser', rooms: 'Room 4' },
          { id: 5, name: 'Period #5', time: '02:00AM - 03:00AM', subject: 'Geography', teacher: 'Tommy Risser', rooms: 'Room 5' },
          { id: 6, name: 'Period #6', time: '04:00AM - 05:00AM', subject: 'Social', teacher: 'Tommy Risser', rooms: 'Room 6' },
          { id: 5, name: 'Period #7', time: '02:00AM - 03:00AM', subject: 'Polyology', teacher: 'Tommy Risser', rooms: 'Room 7' },
          { isBreak: true, id: 1, time: '01 Hr' },
          { id: 6, name: 'Period #8', time: '04:00AM - 05:00AM', subject: 'Social', teacher: 'Tommy Risser', rooms: 'Room 12' }
        ]
      },
      {
        id: 2,
        day: 'Mon',
        periods: [
          { id: 7, name: 'Period #1', time: '08:00AM - 09:00AM', subject: 'Physics', teacher: 'Tommy Risser', rooms: 'Room 12' },
          { id: 8, name: 'Period #2', time: '09:00AM - 10:00AM', subject: 'Chemestry', teacher: 'Tommy Risser', rooms: 'Room 12' },
          { id: 9, name: 'Period #3', time: '11:00AM - 12:00AM', subject: 'Maths', teacher: 'Tommy Risser', rooms: 'Room 12' },
          { isBreak: true, id: 1, time: '01 Hr' },
          { id: 10, name: 'Period #4', time: '01:00AM - 02:00AM', subject: 'Phisics', teacher: 'Tommy Risser', rooms: 'Room 12' },
          { id: 11, name: 'Period #5', time: '02:00AM - 03:00AM', subject: 'History', teacher: 'Tommy Risser', rooms: 'Room 8' },
          { id: 12, name: 'Period #6', time: '04:00AM - 05:00AM', subject: 'Social', teacher: 'Tommy Risser', rooms: 'Room 6' },
          { id: 11, name: 'Period #7', time: '02:00AM - 03:00AM', subject: 'Geography', teacher: 'Tommy Risser', rooms: 'Room 12' },
          { isBreak: true, id: 1, time: '01 Hr' },
          { id: 13, name: 'Period #8', time: '04:00AM - 05:00AM', subject: 'Social', teacher: 'Tommy Risser', rooms: 'Room 5' }
        ]
      },
      {
        id: 3,
        day: 'Tue',
        periods: [
          { id: 7, name: 'Period #1', time: '08:00AM - 09:00AM', subject: 'Physics', teacher: 'Tommy Risser', rooms: 'Room 12' },
          { id: 8, name: 'Period #2', time: '09:00AM - 10:00AM', subject: 'Chemestry', teacher: 'Tommy Risser', rooms: 'Room 7' },
          { id: 9, name: 'Period #3', time: '11:00AM - 12:00AM', subject: 'Maths', teacher: 'Tommy Risser', rooms: 'Room 8' },
          { isBreak: true, id: 1, time: '01 Hr' },
          { id: 10, name: 'Period #4', time: '01:00AM - 02:00AM', subject: 'Phisics', teacher: 'Tommy Risser', rooms: 'Room 5' },
          { id: 11, name: 'Period #5', time: '02:00AM - 03:00AM', subject: 'History', teacher: 'Tommy Risser', rooms: 'Room 12' },
          { id: 12, name: 'Period #6', time: '04:00AM - 05:00AM', subject: 'Social', teacher: 'Tommy Risser', rooms: 'Room 4' },
          { id: 11, name: 'Period #7', time: '02:00AM - 03:00AM', subject: 'Geography', teacher: 'Tommy Risser', rooms: 'Room 12' },
          { isBreak: true, id: 1, time: '01 Hr' },
          { id: 13, name: 'Period #8', time: '04:00AM - 05:00AM', subject: 'Social', teacher: 'Tommy Risser', rooms: 'Room 12' }
        ]
      },
      {
        id: 4,
        day: 'Wed',
        periods: [
          { id: 7, name: 'Period #1', time: '08:00AM - 09:00AM', subject: 'Physics', teacher: 'Tommy Risser', rooms: 'Room 4' },
          { id: 8, name: 'Period #2', time: '09:00AM - 10:00AM', subject: 'Chemestry', teacher: 'Tommy Risser', rooms: 'Room 12' },
          { id: 9, name: 'Period #3', time: '11:00AM - 12:00AM', subject: 'Maths', teacher: 'Tommy Risser', rooms: 'Room 12' },
          { isBreak: true, id: 1, time: '01 Hr' },
          { id: 10, name: 'Period #4', time: '01:00AM - 02:00AM', subject: 'Phisics', teacher: 'Tommy Risser', rooms: 'Room 12' },
          { id: 11, name: 'Period #5', time: '02:00AM - 03:00AM', subject: 'History', teacher: 'Tommy Risser', rooms: 'Room 5' },
          { id: 12, name: 'Period #6', time: '04:00AM - 05:00AM', subject: 'Social', teacher: 'Tommy Risser', rooms: 'Room 4' },
          { id: 11, name: 'Period #7', time: '02:00AM - 03:00AM', subject: 'Geography', teacher: 'Tommy Risser', rooms: 'Room 12' },
          { isBreak: true, id: 1, time: '01 Hr' },
          { id: 13, name: 'Period #8', time: '04:00AM - 05:00AM', subject: 'Social', teacher: 'Tommy Risser', rooms: 'Room 3' }
        ]
      },
      {
        id: 5,
        day: 'Thu',
        periods: [
          { id: 7, name: 'Period #1', time: '08:00AM - 09:00AM', subject: 'Physics', teacher: 'Tommy Risser', rooms: 'Room 12' },
          { id: 8, name: 'Period #2', time: '09:00AM - 10:00AM', subject: 'Chemestry', teacher: 'Tommy Risser', rooms: 'Room 6' },
          { id: 9, name: 'Period #3', time: '11:00AM - 12:00AM', subject: 'Maths', teacher: 'Tommy Risser', rooms: 'Room 10' },
          { isBreak: true, id: 1, time: '01 Hr' },
          { id: 10, name: 'Period #4', time: '01:00AM - 02:00AM', subject: 'Phisics', teacher: 'Tommy Risser', rooms: 'Room 12' },
          { id: 11, name: 'Period #5', time: '02:00AM - 03:00AM', subject: 'History', teacher: 'Tommy Risser', rooms: 'Room 11' },
          { id: 12, name: 'Period #6', time: '04:00AM - 05:00AM', subject: 'Social', teacher: 'Tommy Risser', rooms: 'Room 10' },
          { id: 11, name: 'Period #7', time: '02:00AM - 03:00AM', subject: 'Geography', teacher: 'Tommy Risser', rooms: 'Room 12' },
          { isBreak: true, id: 1, time: '01 Hr' },
          { id: 13, name: 'Period #8', time: '04:00AM - 05:00AM', subject: 'Social', teacher: 'Tommy Risser', rooms: 'Room 11' }
        ]
      }
    ];

    return id === 1 ? arr1 : arr2;
  }

  getTeacherViewSchedule(filter) {
    const arr = [
      {
        id: 1,
        day: 'San',
        periods: [
          { id: 1, name: 'Period #1', time: '08:00AM - 09:00AM', subject: 'English', section: 'G3 -A(2017 -2018)' },
          { id: 2, name: 'Period #2', time: '09:00AM - 10:00AM', subject: 'Arabic', section: 'G3 -A(2017 -2018)' },
          { id: 3, name: 'Period #3', time: '11:00AM - 12:00AM', subject: 'Maths', section: 'G3 -A(2017 -2018)' },
          { isBreak: true, id: 1, time: '01 Hr' },
          { id: 4, name: 'Period #4', time: '01:00AM - 02:00AM', subject: 'English', section: 'G3 -A(2017 -2018)' },
          { id: 5, name: 'Period #5', time: '02:00AM - 03:00AM', subject: 'Arabic', section: 'G3 -A(2017 -2018)' },
          { id: 6, name: 'Period #6', time: '04:00AM - 05:00AM', subject: 'Social', section: 'G3 -A(2017 -2018)' },
          { id: 7, name: 'Period #7', time: '02:00AM - 03:00AM', subject: 'Arabic', section: 'G3 -A(2017 -2018)' },
          { id: 8, name: 'Period #8', time: '04:00AM - 05:00AM', subject: 'Social', section: 'G3 -A(2017 -2018)' }
        ]
      },
      {
        id: 2,
        day: 'Mon',
        periods: [
          { id: 9, name: 'Period #1', time: '08:00AM - 09:00AM', subject: 'English', section: 'G3 -A(2017 -2018)' },
          { id: 10, name: 'Period #2', time: '09:00AM - 10:00AM', subject: 'Arabic', section: 'G3 -A(2017 -2018)' },
          { id: 11, name: 'Period #3', time: '11:00AM - 12:00AM', subject: 'Maths', section: 'G3 -A(2017 -2018)' },
          { isBreak: true, id: 1, time: '01 Hr' },
          { id: 12, name: 'Period #4', time: '01:00AM - 02:00AM', subject: 'English', section: 'G3 -A(2017 -2018)' },
          { id: 13, name: 'Period #5', time: '02:00AM - 03:00AM', subject: 'Arabic', section: 'G3 -A(2017 -2018)' },
          { id: 14, name: 'Period #6', time: '04:00AM - 05:00AM', subject: 'Social', section: 'G3 -A(2017 -2018)' },
          { id: 15, name: 'Period #7', time: '02:00AM - 03:00AM', subject: 'Arabic', section: 'G3 -A(2017 -2018)' },
          { id: 16, name: 'Period #8', time: '04:00AM - 05:00AM', subject: 'Social', section: 'G3 -A(2017 -2018)' }
        ]
      },
      {
        id: 3,
        day: 'Tue',
        periods: [
          { id: 17, name: 'Period #1', time: '08:00AM - 09:00AM', subject: 'English', section: 'G3 -A(2017 -2018)' },
          { id: 18, name: 'Period #2', time: '09:00AM - 10:00AM', subject: 'Arabic', section: 'G3 -A(2017 -2018)' },
          { id: 19, name: 'Period #3', time: '11:00AM - 12:00AM', subject: 'Maths', section: 'G3 -A(2017 -2018)' },
          { isBreak: true, id: 1, time: '01 Hr' },
          { id: 20, name: 'Period #4', time: '01:00AM - 02:00AM', subject: 'English', section: 'G3 -A(2017 -2018)' },
          { id: 21, name: 'Period #5', time: '02:00AM - 03:00AM', subject: 'Arabic', section: 'G3 -A(2017 -2018)' },
          { id: 22, name: 'Period #6', time: '04:00AM - 05:00AM', subject: 'Social', section: 'G3 -A(2017 -2018)' },
          { id: 23, name: 'Period #7', time: '02:00AM - 03:00AM', subject: 'Arabic', section: 'G3 -A(2017 -2018)' },
          { id: 24, name: 'Period #8', time: '04:00AM - 05:00AM', subject: 'Social', section: 'G3 -A(2017 -2018)' }
        ]
      },
      {
        id: 4,
        day: 'Wed',
        periods: [
          { id: 25, name: 'Period #1', time: '08:00AM - 09:00AM', subject: 'English', section: 'G3 -A(2017 -2018)' },
          { id: 26, name: 'Period #2', time: '09:00AM - 10:00AM', subject: 'Arabic', section: 'G3 -A(2017 -2018)' },
          { id: 27, name: 'Period #3', time: '11:00AM - 12:00AM', subject: 'Maths', section: 'G3 -A(2017 -2018)' },
          { isBreak: true, id: 1, time: '01 Hr' },
          { id: 28, name: 'Period #4', time: '01:00AM - 02:00AM', subject: 'English', section: 'G3 -A(2017 -2018)' },
          { id: 29, name: 'Period #5', time: '02:00AM - 03:00AM', subject: 'Arabic', section: 'G3 -A(2017 -2018)' },
          { id: 30, name: 'Period #6', time: '04:00AM - 05:00AM', subject: 'Social', section: 'G3 -A(2017 -2018)' },
          { id: 31, name: 'Period #7', time: '02:00AM - 03:00AM', subject: 'Arabic', section: 'G3 -A(2017 -2018)' },
          { id: 32, name: 'Period #8', time: '04:00AM - 05:00AM', subject: 'Social', section: 'G3 -A(2017 -2018)' }
        ]
      },
      {
        id: 5,
        day: 'Thu',
        periods: [
          { id: 33, name: 'Period #1', time: '08:00AM - 09:00AM', subject: 'English', section: 'G3 -A(2017 -2018)' },
          { id: 34, name: 'Period #2', time: '09:00AM - 10:00AM', subject: 'Arabic', section: 'G3 -A(2017 -2018)' },
          { id: 35, name: 'Period #3', time: '11:00AM - 12:00AM', subject: 'Maths', section: 'G3 -A(2017 -2018)' },
          { isBreak: true, id: 1, time: '01 Hr' },
          { id: 36, name: 'Period #4', time: '01:00AM - 02:00AM', subject: 'English', section: 'G3 -A(2017 -2018)' },
          { id: 37, name: 'Period #5', time: '02:00AM - 03:00AM', subject: 'Arabic', section: 'G3 -A(2017 -2018)' },
          { id: 38, name: 'Period #6', time: '04:00AM - 05:00AM', subject: 'Social', section: 'G3 -A(2017 -2018)' },
          { id: 39, name: 'Period #7', time: '02:00AM - 03:00AM', subject: 'Arabic', section: 'G3 -A(2017 -2018)' },
          { id: 40, name: 'Period #8', time: '04:00AM - 05:00AM', subject: 'Social', section: 'G3 -A(2017 -2018)' }
        ]
      }
    ];

    return arr;
  }

  getSchoolViewSchedule(filter) {
    const arr = [
      {
        id: 1,
        section: 'G1-A',
        year: '2017  - 2018',
        periods: [
          { id: 1, name: 'Period #1', time: '08:00AM - 09:00AM', subject: 'English', teacher: 'Tommy Risser' },
          { id: 2, name: 'Period #2', time: '09:00AM - 10:00AM', subject: 'Arabic', teacher: 'Tommy Risser' },
          { id: 3, name: 'Period #3', time: '11:00AM - 12:00AM', subject: 'Maths', teacher: 'Tommy Risser' },
          { isBreak: true, id: 1, time: '01 Hr' },
          { id: 4, name: 'Period #4', time: '01:00AM - 02:00AM', subject: 'English', teacher: 'Tommy Risser' },
          { id: 5, name: 'Period #5', time: '02:00AM - 03:00AM', subject: 'Arabic', teacher: 'Tommy Risser' },
          { id: 6, name: 'Period #6', time: '04:00AM - 05:00AM', subject: 'Social', teacher: 'Tommy Risser' },
          { id: 7, name: 'Period #7', time: '02:00AM - 03:00AM', subject: 'Arabic', teacher: 'Tommy Risser' },
          { id: 8, name: 'Period #8', time: '04:00AM - 05:00AM', subject: 'Social', teacher: 'Tommy Risser' }
        ]
      },
      {
        id: 2,
        section: 'G1-B',
        year: '2017  - 2018',
        periods: [
          { id: 9, name: 'Period #1', time: '08:00AM - 09:00AM', subject: 'English', teacher: 'Tommy Risser' },
          { id: 10, name: 'Period #2', time: '09:00AM - 10:00AM', subject: 'Arabic', teacher: 'Tommy Risser' },
          { id: 11, name: 'Period #3', time: '11:00AM - 12:00AM', subject: 'Maths', teacher: 'Tommy Risser' },
          { isBreak: true, id: 1, time: '01 Hr' },
          { id: 12, name: 'Period #4', time: '01:00AM - 02:00AM', subject: 'English', teacher: 'Tommy Risser' },
          { id: 13, name: 'Period #5', time: '02:00AM - 03:00AM', subject: 'Arabic', teacher: 'Tommy Risser' },
          { id: 14, name: 'Period #6', time: '04:00AM - 05:00AM', subject: 'Social', teacher: 'Tommy Risser' },
          { id: 15, name: 'Period #7', time: '02:00AM - 03:00AM', subject: 'Arabic', teacher: 'Tommy Risser' },
          { id: 16, name: 'Period #8', time: '04:00AM - 05:00AM', subject: 'Social', teacher: 'Tommy Risser' }
        ]
      },
      {
        id: 3,
        section: 'G1-C',
        year: '2017  - 2018',
        periods: [
          { id: 17, name: 'Period #1', time: '08:00AM - 09:00AM', subject: 'English', teacher: 'Tommy Risser' },
          { id: 18, name: 'Period #2', time: '09:00AM - 10:00AM', subject: 'Arabic', teacher: 'Tommy Risser' },
          { id: 19, name: 'Period #3', time: '11:00AM - 12:00AM', subject: 'Maths', teacher: 'Tommy Risser' },
          { isBreak: true, id: 1, time: '01 Hr' },
          { id: 20, name: 'Period #4', time: '01:00AM - 02:00AM', subject: 'English', teacher: 'Tommy Risser' },
          { id: 21, name: 'Period #5', time: '02:00AM - 03:00AM', subject: 'Arabic', teacher: 'Tommy Risser' },
          { id: 22, name: 'Period #6', time: '04:00AM - 05:00AM', subject: 'Social', teacher: 'Tommy Risser' },
          { id: 23, name: 'Period #7', time: '02:00AM - 03:00AM', subject: 'Arabic', teacher: 'Tommy Risser' },
          { id: 24, name: 'Period #8', time: '04:00AM - 05:00AM', subject: 'Social', teacher: 'Tommy Risser' }
        ]
      },
      {
        id: 4,
        section: 'G1-D',
        year: '2017  - 2018',
        periods: [
          { id: 25, name: 'Period #1', time: '08:00AM - 09:00AM', subject: 'English', teacher: 'Tommy Risser' },
          { id: 26, name: 'Period #2', time: '09:00AM - 10:00AM', subject: 'Arabic', teacher: 'Tommy Risser' },
          { id: 27, name: 'Period #3', time: '11:00AM - 12:00AM', subject: 'Maths', teacher: 'Tommy Risser' },
          { isBreak: true, id: 1, time: '01 Hr' },
          { id: 28, name: 'Period #4', time: '01:00AM - 02:00AM', subject: 'English', teacher: 'Tommy Risser' },
          { id: 29, name: 'Period #5', time: '02:00AM - 03:00AM', subject: 'Arabic', teacher: 'Tommy Risser' },
          { id: 30, name: 'Period #6', time: '04:00AM - 05:00AM', subject: 'Social', teacher: 'Tommy Risser' },
          { id: 31, name: 'Period #7', time: '02:00AM - 03:00AM', subject: 'Arabic', teacher: 'Tommy Risser' },
          { id: 32, name: 'Period #8', time: '04:00AM - 05:00AM', subject: 'Social', teacher: 'Tommy Risser' }
        ]
      },
      {
        id: 5,
        section: 'G1-F',
        year: '2017  - 2018',
        periods: [
          { id: 33, name: 'Period #1', time: '08:00AM - 09:00AM', subject: 'English', teacher: 'Tommy Risser' },
          { id: 34, name: 'Period #2', time: '09:00AM - 10:00AM', subject: 'Arabic', teacher: 'Tommy Risser' },
          { id: 35, name: 'Period #3', time: '11:00AM - 12:00AM', subject: 'Maths', teacher: 'Tommy Risser' },
          { isBreak: true, id: 1, time: '01 Hr' },
          { id: 36, name: 'Period #4', time: '01:00AM - 02:00AM', subject: 'English', teacher: 'Tommy Risser' },
          { id: 37, name: 'Period #5', time: '02:00AM - 03:00AM', subject: 'Arabic', teacher: 'Tommy Risser' },
          { id: 38, name: 'Period #6', time: '04:00AM - 05:00AM', subject: 'Social', teacher: 'Tommy Risser' },
          { id: 39, name: 'Period #7', time: '02:00AM - 03:00AM', subject: 'Arabic', teacher: 'Tommy Risser' },
          { id: 40, name: 'Period #8', time: '04:00AM - 05:00AM', subject: 'Social', teacher: 'Tommy Risser' }
        ]
      }
    ];

    return arr;
  }

  getSectionSchedule(filter) {
    const arr = [
      {
        id: 1,
        day: 'San',
        periods: [
          { id: 1, time: '08:00AM - 09:00AM', "totalMinutes": 0.45 },
          { id: 2, time: '09:00AM - 10:00AM', "totalMinutes": 0.45 },
          { id: 3, time: '11:00AM - 12:00AM', "totalMinutes": 0.45 },
          { id: 4, time: '01:00AM - 02:00AM', "totalMinutes": 0.45 },
          { id: 5, time: '02:00AM - 03:00AM', "totalMinutes": 0.45 },
          { id: 6, time: '04:00AM - 05:00AM', "totalMinutes": 0.45 }
        ]
      },
      {
        id: 2,
        day: 'Mon',
        periods: [
          { id: 7, time: '08:00AM - 09:00AM', "totalMinutes": 0.45 },
          { id: 8, time: '09:00AM - 10:00AM', "totalMinutes": 0.45 },
          { id: 9, time: '11:00AM - 12:00AM', "totalMinutes": 0.45 },
          { id: 10, time: '01:00AM - 02:00AM', "totalMinutes": 0.45 },
          { id: 11, time: '02:00AM - 03:00AM', "totalMinutes": 0.45 },
          { id: 12, time: '04:00AM - 05:00AM', "totalMinutes": 0.45 }
        ]
      },
      {
        id: 3,
        day: 'Tue',
        periods: [
          { id: 13, time: '08:00AM - 09:00AM', "totalMinutes": 0.45 },
          { id: 14, time: '09:00AM - 10:00AM', "totalMinutes": 0.45 },
          { id: 15, time: '11:00AM - 12:00AM', "totalMinutes": 0.45 },
          { id: 16, time: '01:00AM - 02:00AM', "totalMinutes": 0.45 },
          { id: 17, time: '02:00AM - 03:00AM', "totalMinutes": 0.45 },
          { id: 18, time: '04:00AM - 05:00AM', "totalMinutes": 0.45 }
        ]
      },
      {
        id: 4,
        day: 'Wed',
        periods: [
          { id: 19, time: '08:00AM - 09:00AM', "totalMinutes": 0.45 },
          { id: 20, time: '09:00AM - 10:00AM', "totalMinutes": 0.45 },
          { id: 21, time: '11:00AM - 12:00AM', "totalMinutes": 0.45 },
          { id: 22, time: '01:00AM - 02:00AM', "totalMinutes": 0.45 },
          { id: 23, time: '02:00AM - 03:00AM', "totalMinutes": 0.45 },
          { id: 24, time: '04:00AM - 05:00AM', "totalMinutes": 0.45 }
        ]
      },
      {
        id: 5,
        day: 'Thu',
        periods: [
          { id: 25, time: '08:00AM - 09:00AM', "totalMinutes": 0.45 },
          { id: 26, time: '09:00AM - 10:00AM', "totalMinutes": 0.45 },
          { id: 27, time: '11:00AM - 12:00AM', "totalMinutes": 0.45 },
          { id: 28, time: '01:00AM - 02:00AM', "totalMinutes": 0.45 },
          { id: 29, time: '02:00AM - 03:00AM', "totalMinutes": 0.45 },
          { id: 30, time: '04:00AM - 05:00AM', "totalMinutes": 0.45 }
        ]
      }
    ];

    return arr;
  }
}
